<template>
  <div class="gardenDoorsList">
    <el-card>
      <div class="jump-btn">
        <el-button type="primary" @click="back">{{$t('lang.btn_wj_returnNews')}}</el-button>
      </div>
      <el-button type="primary" style="float:right;margin-bottom:10px;" @click="add">新增</el-button>
      <el-table :data="tableData"
        :height="tableData.length > 0 ? require('@/config/enum').tableheight530 : require('@/config/enum').tableheight109"
        class="wid100" :row-class-name="tableRowClassName">
        <el-table-column type="index" :index="indexMethod" align="center" :label="$t('lang.lab_index')" width="100px">
        </el-table-column>
        <el-table-column prop="doorName" label="大门名称"></el-table-column>
        <el-table-column prop="doorPosition" label="位于小区方位">
          <template slot-scope="scope">
            <span v-if="scope.row.doorPosition == 1">东</span>
            <span v-if="scope.row.doorPosition == 2">西</span>
            <span v-if="scope.row.doorPosition == 3">南</span>
            <span v-if="scope.row.doorPosition == 4">北</span>
          </template>
        </el-table-column>
        <el-table-column prop="doorpostNum" label="门岗数量"></el-table-column>
        <el-table-column prop="doorCameraNum" label="监控摄像头数量"></el-table-column>
        <el-table-column prop="hasBikeDoor" label="是否有行车门">
          <template slot-scope="scope">
            <span v-if="scope.row.hasBikeDoor == 1">是</span>
            <span v-if="scope.row.hasBikeDoor == 2">否</span>
          </template>
        </el-table-column>
        <el-table-column prop="isFireDoor" label="是否为消防门">
          <template slot-scope="scope">
            <span v-if="scope.row.isFireDoor == 1">是</span>
            <span v-if="scope.row.isFireDoor == 2">否</span>
          </template>
        </el-table-column>
        <el-table-column prop="operation" :label="$t('lang.lab_operation')"
          :width="require('@/config/enum').opr_width2">
          <template slot-scope="scope">
            <el-button @click="edit(scope.row)">{{$t('lang.btn_modify')}}</el-button>
            <el-button class="orange" @click="deleteOne(scope.row.id)">{{$t('lang.btn_delete')}}</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pageNo"
        :page-sizes="[10, 20, 30, 50]" :page-size="pageSize" layout="sizes, prev, pager, next, jumper"
        :page-count="pageCount" />
    </el-card>
    <!-- 新增小区大门信息弹窗 -->
    <el-dialog title="小区大门信息" :visible.sync="dialogVisible" :close-on-click-modal="false" center top="130px"
      width="900px">
      <el-form :model="ruleForm" name="frm" :rules="rules" ref="ruleForm" class="wid100"
        :label-width="require('@/config/enum').c_ws11" :label-suffix="require('@/config/enum').c_colon">

        <el-form-item tem label="大门名称" prop="doorName">
          <el-input v-model="ruleForm.doorName" placeholder="请输入" class="item-input" style="width:90%" maxlength="50">
          </el-input>
        </el-form-item>
        <el-form-item tem label="位于小区方位" prop="doorPosition">
          <el-select v-model="ruleForm.doorPosition" placeholder="请选择" style="width:90%">
            <el-option v-for="item in doorPosition" :key="item.value" :value="item.value" :label="item.label">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item tem label="门岗数量（个）" prop="doorpostNum">
          <el-input v-model="ruleForm.doorpostNum" placeholder="请输入" class="item-input" style="width:90%"
            maxlength="50">
          </el-input>
        </el-form-item>
        <el-form-item tem label="门岗标配保安数量（个）" prop="doorStaffNum">
          <el-input v-model="ruleForm.doorStaffNum" placeholder="请输入" class="item-input" type="number" style="width:90%"
            maxlength="50">
          </el-input>
        </el-form-item>
        <el-form-item tem label="监控摄像头数量（个）" prop="doorCameraNum">
          <el-input v-model="ruleForm.doorCameraNum" placeholder="请输入" class="item-input" type="number"
            style="width:90%" maxlength="50">
          </el-input>
        </el-form-item>
        <el-form-item tem label="是否有行车门" prop="hasBikeDoor">
          <el-select v-model="ruleForm.hasBikeDoor" placeholder="请选择" style="width:90%">
            <el-option v-for="item in yesorno" :key="item.value" :value="item.value" :label="item.label">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item tem label="是否为消防门" prop="isFireDoor">
          <el-select v-model="ruleForm.isFireDoor" placeholder="请选择" style="width:90%">
            <el-option v-for="item in yesorno" :key="item.value" :value="item.value" :label="item.label">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item tem label="是否有行车栏杆" prop="hasBikeRailing">
          <el-select v-model="ruleForm.hasBikeRailing" placeholder="请选择" style="width:90%">
            <el-option v-for="item in yesorno" :key="item.value" :value="item.value" :label="item.label">
            </el-option>
          </el-select>
        </el-form-item>
        <div class="jump-btn" style="text-align:center">
          <el-button class="detailbtn" type="primary" @click="save('ruleForm')" :disabled="isDisabled">
            保存
          </el-button>
        </div>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
  /**
   *@ClassName:gardenDoorsList
   *@Description:小区大门信息
   *@author:杜斌
   *@Copyright:格众科技
   *@date:2020-02-19
   */
  import {
    mapGetters
  } from 'vuex'
  export default {
    data() {
      return {
        doorPosition: this.$i18n.t('lang.doorPosition'),
        yesorno: this.$i18n.t('lang.yesorno'),
        saveData: '',
        isDisabled: true,
        id: '', // 大门id
        tableData: [], // 大门list
        pageNo: 1, // 页数
        pageSize: 10, // 每页显示数量
        pageCount: 0, // 总页数
        dialogVisible: false, // 新增弹窗状态
        rules: {
          doorName: [{
            required: true,
            message: '请输入大门名称',
            trigger: 'blur'
          }],
          doorPosition: [{
            required: true,
            message: '请选择位于小区方位',
            trigger: 'change'
          }],
          doorpostNum: [{
            required: true,
            message: '请输入门岗数量',
            trigger: 'blur'
          }],
          doorStaffNum: [{
            required: true,
            message: '请输入门岗标配保安数量',
            trigger: 'blur'
          }],
          doorCameraNum: [{
            required: true,
            message: '请输入监控摄像头数量',
            trigger: 'blur'
          }],
          hasBikeDoor: [{
            required: true,
            message: '请选择是否有行车门',
            trigger: 'change'
          }],
          isFireDoor: [{
            required: true,
            message: '请选择是否为消防门',
            trigger: 'change'
          }],
          hasBikeRailing: [{
            required: true,
            message: '请选择是否有行车栏杆',
            trigger: 'change'
          }],
        },
        ruleForm: {
          doorName: '', // 大门名称
          doorPosition: '', // 位于小区方位
          doorpostNum: '', // 门岗数量
          doorStaffNum: '', // 门岗标配保安数量
          doorCameraNum: '', // 监控摄像头数量
          hasBikeDoor: '', // 是否有行车门
          isFireDoor: '', // 是否为消防门
          hasBikeRailing: '', // 是否有行车栏杆
        },
      }
    },
    watch: {
      ruleForm: {
        handler(newVal, oldVal) {
          // ruleForm数据变化时 会调用此方法
          let tempRule = JSON.stringify(newVal)
          if (tempRule === this.saveData) {
            // 没变
            this.isDisabled = true
          } else {
            // 变了
            this.isDisabled = false
          }
        },
        deep: true,
        immediate: true
      }
    },
    computed: {
      ...mapGetters(['gardenId'])
    },
    created() {
      this.getData()
    },
    methods: {
      // 返回上一级
      back() {
        this.$router.push({
          name: 'projectPortrait'
        })
      },
      // 获取大门列表
      getData() {
        let loading = this.$loading()
        this.$get(`/gardenDrawGardenDoor?gardenId=${this.gardenId}&pageNo=${this.pageNo}&pageSize=${this.pageSize}`)
          .then(
            res => {
              loading.close()
              if (res && res.errCode === 0) {
                console.log(res)
                this.tableData = res.list
                this.pageCount = res.pageCount
              }
            },
            error => {
              loading.close()
              this.$message.error(error)
            })
      },
      // 新增大门信息
      add() {
        this.id = ''
        this.ruleForm.doorName = ''
        this.ruleForm.doorPosition = ''
        this.ruleForm.doorpostNum = ''
        this.ruleForm.doorStaffNum = ''
        this.ruleForm.doorCameraNum = ''
        this.ruleForm.hasBikeDoor = ''
        this.ruleForm.isFireDoor = ''
        this.ruleForm.hasBikeRailing = ''
        this.dialogVisible = true
      },
      // 编辑大门信息
      edit(rowData) {
        this.id = rowData.id
        this.ruleForm.doorName = rowData.doorName
        this.ruleForm.doorPosition = rowData.doorPosition
        this.ruleForm.doorpostNum = rowData.doorpostNum
        this.ruleForm.doorStaffNum = rowData.doorStaffNum
        this.ruleForm.doorCameraNum = rowData.doorCameraNum
        this.ruleForm.hasBikeDoor = rowData.hasBikeDoor
        this.ruleForm.isFireDoor = rowData.isFireDoor
        this.ruleForm.hasBikeRailing = rowData.hasBikeRailing
        this.saveData = JSON.stringify(this.ruleForm)
        this.dialogVisible = true
      },
      // 删除大门
      deleteOne(id) {
        let loading = this.$loading()
        this.$confirm(this.$i18n.t('lang.lab_isdelete'), this.$i18n.t('lang.lab_prompt'), {
            confirmButtonText: this.$i18n.t('lang.btn_confirm'),
            cancelButtonText: this.$i18n.t('lang.btn_cancel'),
            type: 'warning'
          }).then(() => {
            this.$delete(`/gardenDrawGardenDoor/` + id).then(
              res => {
                loading.close()
                if (res && res.errCode === 0) {
                  this.$message({
                    type: 'success',
                    message: this.$i18n.t('lang.lab_del_success')
                  })
                  this.getData()
                }
              },
              error => {
                loading.close()
                this.$message.error(error)
              }
            )
          })
          .catch(() => {
            loading.close()
            this.$message({
              type: 'info',
              message: this.$i18n.t('lang.lab_del_can')
            })
          })
      },
      // 保存
      save(formName) {
        let params = this.ruleForm
        params.gardenId = this.gardenId
        console.log('params', params)
        this.$refs[formName].validate((valid) => {
          if (valid) {
            let loading = this.$loading()
            if (!this.id) {
              // 新增
              this.$post('/gardenDrawGardenDoor', params).then(
                res => {
                  loading.close()
                  console.log(res)
                  if (res && res.errCode === 0) {
                    this.$message.success(this.$i18n.t('lang.lab_save_success'))
                    this.getData()
                  }
                },
                error => {
                  loading.close()
                  this.$message.error(error)
                }
              )
            } else {
              // 编辑
              this.$patch(`/gardenDrawGardenDoor/${this.id}`, params).then(
                res => {
                  loading.close()
                  console.log(res)
                  if (res && res.errCode === 0) {
                    this.$message.success(this.$i18n.t('lang.lab_save_success'))
                    this.getData()
                  }
                },
                error => {
                  loading.close()
                  this.$message.error(error)
                }
              )
            }
          } else {
            return false
          }
        })

        this.dialogVisible = false
        this.ruleForm.doorName = ''
        this.ruleForm.doorPosition = ''
        this.ruleForm.doorpostNum = ''
        this.ruleForm.doorStaffNum = ''
        this.ruleForm.doorCameraNum = ''
        this.ruleForm.hasBikeDoor = ''
        this.ruleForm.isFireDoor = ''
        this.ruleForm.hasBikeRailing = ''
      },
      // 翻页
      handleCurrentChange(val) {
        this.pageNo = val
        this.getData()
      },
      // 切换每页显示多少数据
      handleSizeChange(val) {
        this.pageNo = 1
        this.pageSize = val
        this.getData()
      },
      // 表格斑马
      tableRowClassName({
        row,
        rowIndex
      }) {
        return rowIndex % 2 === 0 ? 'row-dark' : ''
      },
      // ID序号功能
      indexMethod(index) {
        return (this.pageNo - 1) * this.pageSize + index + 1
      },
    },
  }
</script>

<style lang="scss">
  .gardenDoorsList {}
</style>